module.exports = __webpack_public_path__ + "img/0824_royalblue.23c936ae.jpg";